import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { convertErrorYup } from '../../utils/helper'
import { addressValid } from '../../validation'
import ModalForm from '../common/modal-form'
import Button from '../elements/Button'
import HeadingForm from '../elements/HeadingForm'
import InputFill from '../form/InputFill'
import Textarea from '../form/Textarea'

const AddressForm = ({ isOpen, closeForm, addressSelected, handleUpdateAddress }) => {
    const [errors, setErrors] = useState({});
    const [form, setForm] = useState({});
    const { t } = useTranslation()

    const fields = [
        {
            label: 'addressMgr.lbStreet',
            name: 'street',
            props: {
                required: true,
            },
        },
        {
            label: 'addressMgr.lbAddressNumber',
            name: 'addressNumber',
            props: {
                required: true,
            },
        },
        {
            label: 'addressMgr.lbZipCode',
            name: 'zipCode',
            props: {
                required: true,
            },
        },
        {
            label: 'addressMgr.lbCity',
            name: 'city',
            props: {
                required: true,
            },
        },
        {
            label: 'addressMgr.lbFloor',
            name: 'floor',
            props: {
                // required: true,
            },
        },
        {
            label: 'addressMgr.lbPhone',
            name: 'phone',
            props: {
                // required: true,
            },
        },
        // {
        //     label: 'addressMgr.lbAddress',
        //     name: 'userAddressNote',
        //     component: Textarea,
        // },
    ]

    const handleInputChange = e => {
        const { name, value } = e.target
        setForm(prev => ({ ...prev, [name]: value }))
    }

    const clearErrorField = field =>
        setErrors(prev => ({ ...prev, [field]: '' }))

    const handleSubmit = async e => {
        e && e.preventDefault()

        try {
            await addressValid.validate(
                form,
                { abortEarly: false }
            )

            handleUpdateAddress(form)
        } catch (error) {
            console.log({ error });
            if (error?.name === 'ValidationError') {
                setErrors(convertErrorYup(error))
            }
        }
    }

    useEffect(() => {
        setErrors({})
        setForm(addressSelected || {})
    }, [ isOpen ])

    return (
        <ModalForm
            isOpen={isOpen}
            onClose={closeForm}
            contentClass="p-0"
            centered
        >
            <HeadingForm className="px-10">{t('addressMgr.titleAdd')}</HeadingForm>
            <hr className="m-0" />
            <form onSubmit={handleSubmit} className="px-4 pb-6">
                <div className="row">
                    {
                        fields.filter(Boolean)
                        .map((field, index) => {
                            const Component =
                                field.component || InputFill
                            return (
                                <div
                                    key={index}
                                    className="col-12 col-md-6"
                                >
                                    <Component
                                        className="mt-6"
                                        label={t(field.label)}
                                        name={field.name}
                                        value={
                                            form[field.name] ?? ''
                                        }
                                        error={errors[field.name]}
                                        onChange={handleInputChange}
                                        onFocus={() =>
                                            clearErrorField(
                                                field.name
                                            )
                                        }
                                        inputStyle={{
                                            borderColor: '#CDCDCD',
                                        }}
                                        {...field.props}
                                    />
                                </div>
                            )
                        })
                    }
                </div>
            </form>
            <hr className="m-0" />
            <div className="text-right p-4">
                <Button
                    onClick={closeForm}
                >
                    {t('addressMgr.btnCancel')}
                </Button>
                <Button
                    className="ml-4"
                    onClick={handleSubmit}
                >
                    {!!addressSelected ? t('addressMgr.btnUpdate') : t('addressMgr.btnAdd')}
                </Button>
            </div>
        </ModalForm>
    )
}

export default AddressForm